import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICDQuartzTheme } from '../../shared/ag-theme';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { DsIconModule, DsToastModule } from '@bmw-ds/components';
import { DsModalModule } from '@bmw-ds/components';
import { DsBoxModule, DsRowData, DsButtonModule, DsFormsModule } from '@bmw-ds/components';
import { DsLoadingAreaConfiguration, DsLoadingAreaService } from '@bmw-ds/components';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import {
  GridApi,
  GridReadyEvent,
  ColDef,
  GridOptions,
  ModuleRegistry,
  AllCommunityModule,
  Theme
} from 'ag-grid-community';
import { ViewDataRendererComponent } from '../../shared/view-data-renderer/view-data-renderer';
import { CheckIconCellRenderer } from 'src/app/shared/checkIconCellRenderer/check-icon-cell-renderer/check-icon-cell-renderer';
import { RemedyStatusIconRenderer } from 'src/app/shared/remedyStatusIconCellRenderer/remedy-status-icon-renderer';
import { StopSaleCellRenderer } from 'src/app/shared/stopSaleCellRenderer/stop-sale-cell-renderer/stop-sale-cell-renderer';
import { CommonService } from 'src/app/services/common.service';
import { hyperlinkWindowCellRenderer } from 'src/app/shared/hyperlinkWindowCellRenderer/hyperlink-window-cell-rendere';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExportService } from 'src/app/services/export.service';
import { environment } from 'src/environments/environment';
import { DsToastService, DsToastModel } from '@bmw-ds/components';

ModuleRegistry.registerModules([AllCommunityModule]);

@Component({
  selector: 'app-vehicle-campaign-details',
  standalone: true,
  imports: [CommonModule, DsBoxModule, AgGridModule, AgGridAngular, DsButtonModule, DsIconModule, DsModalModule, DsFormsModule, FormsModule, ReactiveFormsModule, DsToastModule],
  templateUrl: './vehicle-campaign-details.html',
  styleUrl: './vehicle-campaign-details.scss',
})
export class VehicleCampaignDetails implements OnInit, OnDestroy {
  isRowSelected: boolean = false;
  scrollHeight: string = '320px';
  readonly environment = environment;
  readonly rowHeight = 40;
  readonly headerHeight = 90;
  readonly floatingFiltersHeight = 30;
  readonly paginationPanelHeight = 48;
  inventory: string = '';
  defectCode: string = '';
  campaignStatus: string = '';
  demoLoanerCount: string = '';
  vinCount: any = '';
  centerCode: any;
  dealerCode: any;
  internal: any;
  isBackButtonPresent: boolean = false;
  vdcDownloadResponse: any;
  selectedCriteria: Record<string, any> = {};
  dealerDesc: string = '';
  disclaimer: string = '';
  currentDate: string = '';
  currentTime: string = '';
  defectCodeDesc: any;
  isSubmitting: boolean = false;
  formSubmitted: boolean = false;
  userInfo: any;
  isICDFloatingFilterActive: boolean = false;
  activeICDFilterValues: { colId: string; value: string; }[] = [];
  constructor(private route: ActivatedRoute, private exportService: ExportService, private commonService: CommonService, private apiService: ApiService, private toastService: DsToastService, private loadingAreaService: DsLoadingAreaService, private router: Router) { }
  theme: Theme | "legacy" = ICDQuartzTheme;
  noRowsTemplate = '<div class="icd-no-rows" role="status" aria-live="polite">No Rows Found</div>';
  paginationPageSize: number = 10;
  paginationPageSizeSelector: number[] | boolean = [10, 20, 30];
  rowData: DsRowData[] = [];
  private gridApi!: GridApi;
  columnName: string = '';
  VCDTableDynamicData: any;
  Value: any = '';
  isVCDFloatingFilterActive: boolean = false;
  activeVCDFilterValues: { colId: string; value: string }[] = [];
  // ← debounce timer — prevents firing on every keystroke
  private filterDebounceTimer: any = null;
  private readonly FILTER_DEBOUNCE_MS = 600;
  // ← VCD table floating filter columns
  private readonly floatingFilterCols = [
    'VINandAirLink',
    'Inventory',
    'SubInventory',
    'EngineeringSeries',
    'NAModelCodeDescription',
    'ModelYear'
  ];
  loadingAreaConfig: DsLoadingAreaConfiguration = {
    id: 'bodyLoading',
    loadingTitle: 'Details are being displayed, this may take few seconds..',
    loadingText: 'Please do not close the browser window. wait while we load data.'
  };
  private isRemedyRedColor = (params: any) => String(params?.data?.RemedyStatusAllOpenCampaignsColor ?? '').trim().toLowerCase() === 'y';
  notInInventoryForm = new FormGroup({
    notInInventoryTextarea: new FormControl('', [Validators.required, Validators.minLength(7), Validators.maxLength(500)]),
  })
  ngOnInit() {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.noRowsTemplate = `<div class="icd-no-rows" role="status" aria-live="polite"> Loading table data ...</div>`;
    this.route.queryParams.subscribe((params: any) => {
      // console.log(params);
      this.columnName = params['column'];

      this.Value = params['value'];
      this.defectCode = params['defectCode'];
    })
    if (!this.columnName || !this.defectCode) {
      this.noRowsTemplate = `<div class="icd-no-rows" role="status" aria-live="polite">Required parameters are missing. Please access this page through the Inventory Campaign Details dashboard.</div>`;
      this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      return;
    }
    this.commonService.selectedCriteria.subscribe((data: any) => {
      // console.log('Selected Criteria:', data);
      this.campaignStatus = data?.['Vehicle Campaign Status'] ?? this.campaignStatus;
      this.demoLoanerCount = data?.['Demo / Loaner Vehicle Count'] ?? this.demoLoanerCount;
    });
    this.currentDate = this.commonService.currentDate as string;
    this.currentTime = this.commonService.currentTime + ' EST' as string;
    this.commonService.dealerCode.subscribe((data: any) => {
      // console.log('Dealer Code:', data);
      this.dealerCode = data ?? this.dealerCode;
    });
    this.commonService.dealerDesc.subscribe((desc) => {
      this.dealerDesc = desc;
    });
    this.commonService.disclaimer.subscribe((disclaimer) => {
      this.disclaimer = disclaimer;
    });
    this.commonService.isBackButtonPresent.subscribe((isPresent: boolean) => {
      this.isBackButtonPresent = isPresent;
    });
    this.commonService.selectedCriteria.subscribe((criteria) => {
      this.selectedCriteria = criteria;
      // console.log('Received criteria in table component:', criteria);
    });
    this.userInfo = this.commonService.getUserInfo();
    if (this.commonService.isFloatingFilterActive) {
      this.commonService.isFloatingFilterActive.subscribe((isActive: boolean) => {
        this.isICDFloatingFilterActive = isActive;
        console.log('Floating filter active in form:', isActive);
      });
    }

    if (this.commonService.agGridFilters) {
      this.commonService.agGridFilters.subscribe((filters: { colId: string; value: string }[]) => {
        this.activeICDFilterValues = filters;
        console.log('Active filter values in form:', filters);
      });
    }
    this.vechileCampaignDetailsAPI();
  }

  private getVisibleRowsBodyHeight(): number {
    if (!this.gridApi) {
      return Math.max(this.rowData.length, 1) * this.rowHeight;
    }

    const displayedRowCount = this.gridApi.getDisplayedRowCount();
    if (displayedRowCount === 0) {
      return this.rowHeight;
    }

    const currentPage = this.gridApi.paginationGetCurrentPage();
    const pageSize = this.gridApi.paginationGetPageSize();
    const startIndex = currentPage * pageSize;
    const endIndex = Math.min(startIndex + pageSize, displayedRowCount);

    let totalBodyHeight = 0;
    for (let index = startIndex; index < endIndex; index += 1) {
      const rowNode = this.gridApi.getDisplayedRowAtIndex(index);
      totalBodyHeight += rowNode?.rowHeight ?? this.rowHeight;
    }

    return Math.max(totalBodyHeight, this.rowHeight);
  }

  private syncTableHeightToGridState(): void {
    const bodyHeight = this.getVisibleRowsBodyHeight();
    const chromeHeight = this.headerHeight + this.floatingFiltersHeight + this.paginationPanelHeight;
    this.scrollHeight = `${chromeHeight + bodyHeight + 16}px`;

    if (!this.gridApi) {
      return;
    }

    const displayedRowCount = this.gridApi.getDisplayedRowCount();
    this.vinCount = displayedRowCount;
    if (this.vinCount === '0' || this.vinCount === null || this.vinCount === undefined) {
      this.noRowsTemplate = `<div class="icd-no-rows" role="status" aria-live="polite">No rows found</div>`;
    }
    if (displayedRowCount > 0) {
      this.gridApi.hideOverlay?.();
      return;
    }
    if (displayedRowCount === 0) {
      if (this.isVCDFloatingFilterActive) {
        // ← filter is active but no rows match
        this.noRowsTemplate = `
          <div class="icd-no-rows" role="status" aria-live="polite">
            <span>No matching rows found for the applied filter(s).</span>
            <br/>
            <span style="font-size:12px; color:#888;">Try adjusting or clearing the filter.</span>
          </div>`;
      }
      else if (this.rowData.length === 0) {
        this.noRowsTemplate = `<div class="icd-no-rows" role="status" aria-live="polite">No data found</div>`;
      }
      this.gridApi.showNoRowsOverlay?.();

    }
  }


  vechileCampaignDetailsAPI() {
    if (this.columnName) {
      if (this.columnName === 'DealerInventory') {
        this.columnName = 'Dealer-Inv';
      } else if (this.columnName === 'DemoLoaner') {
        this.columnName = 'Demo-Loaner';
      } else if (this.columnName === 'PreOwned') {
        this.columnName = 'Pre-Owned';
      }
      else {
        this.columnName = 'ALL';
      }
    }
    const vcdPayload = {
      "mainInventory": this.columnName ?? null,
      "defectCd": this.defectCode,
      "centerID": this.dealerCode,
      "vehicleCampaignStatus": this.campaignStatus,
      "demoOrLoanerVehicle": this.demoLoanerCount,
      "lineMakesSelected": this.selectedCriteria['Line Make'] ?? null,
      "campaignTypesSelected": this.selectedCriteria['Campaign Type'] ?? null,
      "enggSeriesSelected": this.selectedCriteria['Engineering Series'] ?? null,
      "modelYearsSelected": this.selectedCriteria['Model Year'] ?? null,
      "locationsSelected": this.selectedCriteria['Location'] ?? null,
      "vinCount": this.Value,
      "coloumnFilter": this.isICDFloatingFilterActive,
      "defectCodeFilter": this.activeICDFilterValues.find(f => f.colId === "DefectCode")?.value ? true : false,
      "defectDescFilter": this.activeICDFilterValues.find(f => f.colId === "DefectDescription")?.value ? true : false,
      "bulletinNumberFilter": this.activeICDFilterValues.find(f => f.colId === "BulletinNumber")?.value ? true : false,
      "recallNumberFilter": this.activeICDFilterValues.find(f => f.colId === "RecallNumber")?.value ? true : false,
      "defectCodeSelected": this.activeICDFilterValues.find(f => f.colId === "DefectCode")?.value || '',
      "defectDescSelected": this.activeICDFilterValues.find(f => f.colId === "DefectDescription")?.value || '',
      "bulletinNumberSelected": this.activeICDFilterValues.find(f => f.colId === "BulletinNumber")?.value || '',
      "recallNumberSelected": this.activeICDFilterValues.find(f => f.colId === "RecallNumber")?.value || ''
    };
    this.apiService.getVCDTableData(vcdPayload).subscribe({
      next: (data: any) => {
        this.VCDTableDynamicData = data;
        // console.log(this.VCDTableDynamicData);
        this.inventory = this.VCDTableDynamicData?.inventory ?? this.inventory;
        this.defectCodeDesc = this.VCDTableDynamicData?.defectCode_Desc ?? this.defectCodeDesc;
        this.campaignStatus = this.VCDTableDynamicData?.vehicleCampaignStatus ?? this.campaignStatus;
        this.demoLoanerCount = this.VCDTableDynamicData?.demoOrLoanerVehicle ?? this.demoLoanerCount;
        this.vinCount = this.VCDTableDynamicData?.vinCount ?? this.vinCount;
        this.rowData = (this.VCDTableDynamicData?.vehicleCampaignDetails ?? []).map((row: any) => {
          const remedyRaw = row?.remedyStatusAllOpenCampaigns;
          const remedyList = Array.isArray(remedyRaw)
            ? remedyRaw
            : (remedyRaw ? [remedyRaw] : []);
          // Map each item with its own color — red if 'y', black if 'n'
          const mappedRemedyList = remedyList.map((r: any) => ({
            remedyStatus: this.commonService.cleanMojibake(  // ← add cleanMojibake here
              String(r?.remedyStatus ?? '').trim()
            ),
            defectStopSaleFlag: String(r?.defectStopSaleFlag ?? '').trim().toLowerCase(),
            remedyStatusCode: r?.remedyStatusCode ?? '',
            // ← per item color flag
            isRed: String(r?.defectStopSaleFlag ?? '').trim().toLowerCase() === 'y',
          }));

          // Row level — red if ANY item has 'y'
          const hasAnyStopSale = mappedRemedyList.some((r: any) => r.isRed);
          return {
            StopSale: row?.stopSaleFlg ?? null,
            OverallRemedyAvailable: row?.overallRemedyAvl ?? null,
            VINandAirLink: row?.vin ?? null,
            vinUrl: environment.isB2E ? row?.warrantyVehicleInternalUrl : row?.warrantyVehicleDealerUrl ?? null,
            airUrl: environment.isB2E ? row?.airInternalUrl : row?.airDealerUrl ?? null,
            Inventory: row?.vehicleInventory ?? null,
            SubInventory: row?.subInventory ?? null,
            PriorityCode: row?.priorityCode ?? null,
            LineMakeDescription: row?.lineMakeDesc ?? null,
            EngineeringSeries: row?.engineeringSeries ?? null,
            NAModelCodeDescription: row?.namodelCodeDescription ?? null,
            ModelYear: row?.modelYear ?? null,
            RemedyStatusAllOpenCampaignsIcon: row?.overallRemedyAvl ?? null,
            RemedyStatusAllOpenCampaigns: mappedRemedyList,
            RemedyStatusAllOpenCampaignsColor: hasAnyStopSale ? 'y' : 'n',
            VehicleNotInInventory: null,
          };
        });
        this.syncTableHeightToGridState();


      },
      error: (error) => {
        console.error('Error fetching Vehicle Campaign Details data:', error);
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id); // Removes the loading area
      },
      complete: () => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      }

    });

  }

  downloadApiImplementation(format: 'pdf' | 'csv', scope: 'total') {
    const fileDownloadPayload = {
      "centerID": this.dealerCode || '',
      "inventoryCampaignDetails": "Dealer " + this.dealerCode + " - " + this.dealerDesc,
      "lineMakesSelected": this.selectedCriteria['Line Make'] || 'ALL',
      "campaignTypesSelected": this.selectedCriteria['Campaign Type'] || 'ALL',
      "enggSeriesSelected": this.selectedCriteria['Engineering Series'] || 'ALL',
      "modelYearsSelected": this.selectedCriteria['Model Year'] || 'ALL',
      "locationsSelected": this.selectedCriteria['Location'] || 'ALL',
      "selectedVehicleCampaignStaus": this.selectedCriteria['Vehicle Campaign Status'],
      "selectedDemoLnrOption": this.selectedCriteria['Demo / Loaner Vehicle Count'],
      "mainInventory": this.columnName ?? 'ALL',
      "defectCd": this.defectCode ?? '',
      "disclaimer": this.disclaimer || '',
      "exportToPDF": false,
      "exportToCSV": false,
      "totalDealerVINExportToPDF": (format === 'pdf' && scope === 'total') ? true : false,
      "totalDealerVINExportToCSV": (format === 'csv' && scope === 'total') ? true : false,
      //ICD related filters
      "coloumnFilter": this.isICDFloatingFilterActive || this.isVCDFloatingFilterActive,
      "defectCodeFilter": this.activeICDFilterValues.find(f => f.colId === "DefectCode")?.value ? true : false,
      "defectDescFilter": this.activeICDFilterValues.find(f => f.colId === "DefectDescription")?.value ? true : false,
      "bulletinNumberFilter": this.activeICDFilterValues.find(f => f.colId === "BulletinNumber")?.value ? true : false,
      "recallNumberFilter": this.activeICDFilterValues.find(f => f.colId === "RecallNumber")?.value ? true : false,
      "defectCodeSelected": this.activeICDFilterValues.find(f => f.colId === "DefectCode")?.value || '',
      "defectDescSelected": this.activeICDFilterValues.find(f => f.colId === "DefectDescription")?.value || '',
      "bulletinNumberSelected": this.activeICDFilterValues.find(f => f.colId === "BulletinNumber")?.value || '',
      "recallNumberSelected": this.activeICDFilterValues.find(f => f.colId === "RecallNumber")?.value || '',
      //vcd filters related payload:
      "vinFilter": !!this.getFilterValue('VINandAirLink'),
      "inventoryFilter": !!this.getFilterValue('Inventory'),
      "subInventoryFilter": !!this.getFilterValue('SubInventory'),
      "engineSeriesFilter": !!this.getFilterValue('EngineeringSeries'),
      "naModelCodeFilter": !!this.getFilterValue('NAModelCodeDescription'),
      "modelYearFilter": !!this.getFilterValue('ModelYear'),

      "vinSelected": this.getFilterValue('VINandAirLink'),
      "inventorySelected": this.getFilterValue('Inventory'),
      "subInventorySelected": this.getFilterValue('SubInventory'),
      "engineSeriesSelected": this.getFilterValue('EngineeringSeries'),
      "naModelCodeSelected": this.getFilterValue('NAModelCodeDescription'),
      "modelYearSelected": this.getFilterValue('ModelYear'),
    }

    // console.log('File Download Payload:', fileDownloadPayload);

    this.apiService.getDownloadFiles(fileDownloadPayload).subscribe({
      next: (data: any) => {
        this.vdcDownloadResponse = data;
      },
      error: (error: any) => {
        console.log('Error in fetching download files', error);
      },
      complete: () => {
        if (format === 'pdf') {
          this.vdcExportPdf(this.vdcDownloadResponse);
        }
        if (format === 'csv') {
          this.vdcExportExcel(this.vdcDownloadResponse);
        }
        console.log('Download files request completed');
      },
    });
  }

  private formatColLabel(colId: string): string {
    if (colId === 'VINandAirLink') {
      return 'VIN';
    }

    if (colId === 'NAModelCodeDescription') {
      return 'NA Model Code Description';
    }
    return colId
      .replace(/([A-Z])/g, ' $1') // ← add space before each capital letter
      .trim();                      // ← remove leading space
  }

  vdcExportPdf(downloadResponse?: any) {
    const heading = downloadResponse?.inventoryCampaignDetails ?? '';
    const toDetails = (obj: Record<string, any> | undefined) => {
      const entries = Object.entries(obj ?? {});
      return entries.map(([label, value]) => ({ label, value })).filter(d => d.label.trim().toLowerCase() !== 'center code');
    };

    const baseDetails = toDetails(this.selectedCriteria).concat([
      { label: 'Inventory', value: this.inventory },
      { label: 'Details as of', value: this.currentDate + ' at ' + this.currentTime },
    ]);
    const filterDetails = this.isVCDFloatingFilterActive
      ? this.activeVCDFilterValues.map(f => ({
        label: `${this.formatColLabel(f.colId)} contains:`,
        value: f.value
      }))
      : [];
    const details = [...baseDetails, ...filterDetails];
    const centerCode = this.dealerCode && this.dealerDesc ? `${this.dealerCode} - ${this.dealerDesc}` : null;
    const dealerTitle = `${heading || (this.dealerCode ? `${this.dealerCode} - ${this.dealerDesc}` : (centerCode || ''))}`;
    const fullCols = [
      'StopSale', 'OverallRemedyAvailable', 'VINandAirLink', 'Inventory', 'SubInventory', 'PriorityCode',
      'LineMakeDescription', 'EngineeringSeries', 'NAModelCodeDescription', 'ModelYear', 'RemedyStatusAllOpenCampaigns',
    ];
    const fullHeaders = [
      'Stop Sale', 'Overall Remedy Available(ORA)', 'VIN', 'Inventory', 'Sub Inventory', 'Priority Code',
      'Line Make Description', 'Engineering Series', 'NAModel Code Description', 'Model Year', 'Remedy Status - All Open Campaigns',

    ];
    const fileDownloadTableData = (downloadResponse?.campaignInventoryExportModel ?? []).map((row: any) => {
      const remedyRaw = row?.remedyStatusAllOpenCampaigns;
      const remedyList = Array.isArray(remedyRaw) ? remedyRaw : (remedyRaw ? [remedyRaw] : []);
      return {
        StopSale: row['stopSaleFlg'] ?? null,
        OverallRemedyAvailable: row['overallRemedyAvl'] ?? null,
        VINandAirLink: row['vin'] ?? null,
        Inventory: row['inventory'] ?? null,
        SubInventory: row['subInventory'] ?? null,
        PriorityCode: row['priorityCode'] ?? null,
        LineMakeDescription: row['lineMakeDescription'] ?? null,
        EngineeringSeries: row['engineSeries'] ?? null,
        NAModelCodeDescription: row['naModelCodeDesc'] ?? null,
        ModelYear: row['modelYear'] ?? null,
        RemedyStatusAllOpenCampaigns: this.formatRemedyForPdf(row?.remedyStatusAllOpenCampaigns) || null,
        VCDColor: (this.formatRemedyForPdf(row?.remedyStatusAllOpenCampaigns)?.includes('red')) ? 'red' : '',
        VehicleNotInInventory: null,

        Color: (row['stopSaleFlg'] === true
          || String(row['stopSaleFlg']).trim().toLowerCase() === 'y'
          || String(row['stopSaleFlg']).trim().toLowerCase() === 'yes'
          || String(row['stopSaleFlg']).trim().toLowerCase() === 'true') ? 'red' : '',
      }
    });
    this.exportService.exportPdfWithDetails(
      'VCD_Export',
      fileDownloadTableData,
      fullCols,
      fullHeaders,
      details,
      {
        title: 'Inventory Campaign Details',
        dealerTitle: dealerTitle,
        disclaimer: this.disclaimer,
        printedOn: this.currentDate + ' at ' + this.currentTime,
        orientation: 'landscape',
        rowHeight: 40,
        cellPadding: 8,
        headerFillColor: '#e0e0e0',
        headerTextColor: '#0e0e0e',
        textColor: '#1a1a1a',
        zebraFillColor: '#f5f5f5',
        columnWidths: [60, 90, 200, 100, 100, 80, 120, 110, 150, 100, 260],
        renderIcons: true,
        pinnedBottomFillColor: '#e3f2fd',
      }
    );
  }

  private formatRemedyForPdf(remedyRaw: any): string {
    const list = Array.isArray(remedyRaw) ? remedyRaw : (remedyRaw ? [remedyRaw] : []);
    return list
      .map((r: any) => {
        const flag = String(r?.defectStopSaleFlag ?? '').trim().toLowerCase();
        const color = flag === 'y' ? 'red' : 'black';
        const iconCode = r?.remedyStatusCode ? String(r.remedyStatusCode).trim() : '';
        const status = this.commonService.cleanMojibake( // ← clean special chars
          String(r?.remedyStatus ?? '').trim()
        );
        return `${color} '@' ${iconCode} - ${status} `;
      })
      .filter(Boolean)
      .join('\n'); // newline => list-like in PDF cell
  }

  private formatRemedyForCsv(remedyRaw: any): string {
    const list = Array.isArray(remedyRaw) ? remedyRaw : (remedyRaw ? [remedyRaw] : []);
    return list
      .map((r: any) => {
        const flag = String(r?.defectStopSaleFlag ?? '').trim().toLowerCase();
        const iconText = r?.remedyStatusCode ? String(r.remedyStatusCode).trim() : '';
        const status = this.commonService.cleanMojibake( // ← clean special chars
          String(r?.remedyStatus ?? '').trim()
        );
        return `${iconText}${iconText && status ? ' - ' : ''}${status}`;
      })
      .filter(Boolean)
      .join(' | '); // single-line for CSV
  }
  vdcExportExcel(downloadResponse?: any) {
    const toDetails = (obj: Record<string, any> | undefined) => {
      const entries = Object.entries(obj ?? {});
      return entries.map(([label, value]) => ({ label, value })).filter(d => d.label.trim().toLowerCase() !== 'center code');
    };
    const baseDetails = toDetails(this.selectedCriteria).concat([
      { label: 'Inventory', value: this.inventory },
      { label: 'Details as of', value: this.currentDate + ' at ' + this.currentTime },
    ]);
    const filterDetails = this.isVCDFloatingFilterActive
      ? this.activeVCDFilterValues.map(f => ({
        label: `${this.formatColLabel(f.colId)} contains:`,
        value: f.value
      }))
      : [];
    const details = [...baseDetails, ...filterDetails];
    const centerCode = this.dealerCode && this.dealerDesc ? `${this.dealerCode} - ${this.dealerDesc}` : null;

    // Check if we should use grid columns or full export columns
    const useGridColumns = this.isBackButtonPresent; // Modify this condition as needed


    // Export Type 2: Full export with all columns from API
    const fullCols = [
      'VIN', 'Chassis', 'StopSale', 'OverallRemedyAvailable', 'ORAStatusDate',
      'RemedyStatus', 'Inventory', 'SubInventory', 'PriorityCode', 'ProductionDate',
      'LineMakeDescription', 'EngineeringSeries', 'ModelYear', 'NAModelCodeDescription',
      'Region', 'Market', 'CenterID', 'LocationCode', 'DefectCode', 'DefectDescription',
      'BulletinNumber', 'RecallNumber', 'CampaignType'
    ];
    const fullHeaders = [
      'VIN', 'Chassis', 'Stop Sale', 'Overall Remedy Available(ORA)', 'ORA Status Date',
      'Remedy Status', 'Inventory', 'Sub Inventory', 'Priority Code', 'Production Date',
      'Line Make Description', 'Engineering Series', 'Model Year', 'NA Model Code - Description',
      'Region', 'Market', 'Center ID', 'Location Code', 'Defect Code', 'Defect Description',
      'Bulletin Number', 'Recall Number', 'Campaign Type'
    ];

    const vcdRowsForExport = (downloadResponse?.campaignInventoryExportModel ?? []).map((row: any) => {
      const remedy = Array.isArray(row?.remedyStatusAllOpenCampaigns)
        ? row.remedyStatusAllOpenCampaigns[0]
        : row?.remedyStatusAllOpenCampaigns;
      return {
        VIN: row['vin'] ?? null,
        Chassis: row['chasis_11_17'] ?? null,
        StopSale: row['stopSaleFlg'] ?? null,
        OverallRemedyAvailable: row['overallRemedyAvl'] ?? null,
        ORAStatusDate: row['oraStatusDate'] ?? null,
        RemedyStatus: this.formatRemedyForCsv(row?.remedyStatusAllOpenCampaigns) || null,
        Inventory: row['inventory'] ?? null,
        SubInventory: row['subInventory'] ?? null,
        PriorityCode: row['priorityCode'] ?? null,
        ProductionDate: row['prodDate'] ?? null,
        LineMakeDescription: row['lineMakeDescription'] ?? null,
        EngineeringSeries: row['engineSeries'] ?? null,
        ModelYear: row['modelYear'] ?? null,
        NAModelCodeDescription: row['naModelCodeDesc'] ?? null,
        Region: row['region'] ?? null,
        Market: row['market'] ?? null,
        CenterID: row['centerID'] ?? null,
        LocationCode: row['locationCode'] ?? null,
        DefectCode: row['defectCode'] ?? null,
        DefectDescription: this.commonService.cleanMojibake(row['defectDesc'] ?? null),
        BulletinNumber: row['bulletinNber'] ?? null,
        RecallNumber: row['recallNber'] ?? null,
        CampaignType: row['campaignType'] ?? null,
      };
    });

    // console.log('Full Export - Rows:', vcdRowsForExport);
    this.exportService.exportCsvWithDetails(
      'VCD_Export',
      vcdRowsForExport,
      centerCode ? [`Center Code: ${centerCode}`] : [],
      fullCols,
      fullHeaders,
      details,
      { title: '', addBom: true }
    );

  };

  maxCommentLength = 500;
  comment: string = '';

  get remainingChars(): number {
    const value = (this.notInInventoryForm?.get('notInInventoryTextarea')?.value as string) ?? this.comment ?? '';
    const len = value.length;
    const remaining = this.maxCommentLength - len;
    return remaining < 0 ? 0 : remaining;
  }

  onCommentInput(value: string) {
    this.comment = value?.slice(0, this.maxCommentLength);
  }

  onDataViewClick(params: any) {
    // console.log('View Data Clicked', params);
    const value = params.value ?? '';
    const columnName = params?.colDef?.field ?? params?.column?.getColId?.() ?? '';
    this.router.navigate(['vcd'], {
      queryParams: {
        column: columnName,
        value: value,
        defectCode: params.data?.DefectCode ?? null,
      },
    });
  }

  columns: ColDef[] = [
    {
      field: 'StopSale',
      headerName: 'Stop Sale',
      maxWidth: 70,
      filter: false,
      cellRenderer: StopSaleCellRenderer,
      //need to add the icon here
    },
    {
      field: 'OverallRemedyAvailable',
      headerName: 'Overall Remedy Available',
      maxWidth: 90,
      filter: false,
      flex: 1,
      cellRenderer: CheckIconCellRenderer,


    },
    {
      field: 'VINandAirLink',
      headerName: 'VIN and Air Link',
      filter: true,
      flex: 1,
      minWidth: 220,
      wrapText: true,
      cellRenderer: hyperlinkWindowCellRenderer,
      cellRendererParams: {
        onClick: this.onDataViewClick.bind(this),
      },


    },
    {
      field: 'Inventory',
      headerName: 'Inventory',
      flex: 1,
      filter: true,
      autoHeight: true,
      maxWidth: 100,
      wrapText: true,
    },
    {
      field: 'SubInventory',
      headerName: 'Sub Inventory',
      tooltipField: 'SubInventory',
      filter: true,
      wrapText: true,
      autoHeight: true,
    },
    {
      field: 'PriorityCode',
      headerName: 'Priority Code',
      autoHeight: true,
      filter: false,
      flex: 1,
      maxWidth: 80,
      wrapText: true,
    },
    {
      field: 'LineMakeDescription',
      headerName: 'Line Make Description',
      tooltipField: 'refId',
      wrapText: true,
      autoHeight: true,
      sortable: true,
      filter: false,
      flex: 1,
    },
    {
      field: 'EngineeringSeries',
      headerName: 'Engineering Series',
      autoHeight: true,
      wrapText: true,
      filter: true,
      flex: 1,

    },
    {
      field: 'NAModelCodeDescription',
      headerName: 'NA Model Code - Description',
      tooltipField: 'eventType',
      autoHeight: true,
      sortable: true,
      filter: true,
      flex: 1,
      wrapText: true,

    },
    {
      field: 'ModelYear',
      headerName: 'Model Year',
      sortable: true,
      maxWidth: 90,
      filter: true,
      flex: 1,

    },
    {
      field: 'RemedyStatusAllOpenCampaigns',
      headerName: 'Remedy Status - All Open Campaigns',
      filter: false,
      flex: 1,
      minWidth: 240,
      cellRenderer: RemedyStatusIconRenderer,
      wrapText: true,
      cellClassRules: { 'color-red': (params) => this.isRemedyRedColor(params) },
    },
    {
      field: 'VehicleNotInInventory',
      headerName: 'Vehicle Not In Inventory',
      filter: false,
      flex: 1,
      maxWidth: 100,
      checkboxSelection: true,
      // headerCheckboxSelection: true,
      cellRendererParams: {
        //  onClick: this.selectedRow.bind(this),
      },
    }

  ];
  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    floatingFilter: true,
    wrapHeaderText: true,
    autoHeight: true,
    filterParams: {
      closeOnApply: true,
      suppressAndOrCondition: true,
      maxNumConditions: 1,
      trimInput: false,
      filterOptions: [        // ? explicitly list all filter options you want
        'contains',
      ],
      defaultOption: 'contains',
    },
    headerCheckboxSelectionFilteredOnly: true,

  };

  gridOptions: GridOptions = {
    suppressRowClickSelection: true,
    rowSelection: 'multiple',
    animateRows: true,
    enableCellTextSelection: true,
    ensureDomOrder: true,
    floatingFiltersHeight: 30,
  };

  onGridReady(params: GridReadyEvent) {
    params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    this.syncTableHeightToGridState();
    // console.log('Grid API:', this.gridApi);
  }

  onFirstDataRendered(): void {
    this.syncTableHeightToGridState();
  }

  onModelUpdated(): void {
    this.syncTableHeightToGridState();
  }

  onPaginationChanged(): void {
    if (!this.gridApi) {
      return;
    }

    this.paginationPageSize = this.gridApi.paginationGetPageSize();
    this.syncTableHeightToGridState();
  }

  onVCDFilterChanged(): void {
    this.syncTableHeightToGridState();

    // ← reset timer on every keystroke
    if (this.filterDebounceTimer) {
      clearTimeout(this.filterDebounceTimer);
      this.filterDebounceTimer = null;
    }

    // ← wait 600ms after user stops typing THEN store
    this.filterDebounceTimer = setTimeout(() => {
      this.filterDebounceTimer = null;
      this.trackVCDActiveFilters();
      this.syncTableHeightToGridState();
    }, this.FILTER_DEBOUNCE_MS);
  }

  // ← stores active filter values — called after debounce
  private trackVCDActiveFilters(): void {
    if (!this.gridApi) return;

    const filterModel = this.gridApi.getFilterModel();
    // console.log('VCD filterModel:', filterModel);

    // ← collect only active filters with values
    this.activeVCDFilterValues = this.floatingFilterCols
      .filter((colId: string) => !!filterModel[colId]?.filter)
      .map((colId: string) => ({
        colId,
        value: String(filterModel[colId]?.filter ?? ''),
      }));

    const wasActive = this.isVCDFloatingFilterActive;
    const isActive = this.activeVCDFilterValues.length > 0;

    this.isVCDFloatingFilterActive = isActive;

    console.log('wasActive:', wasActive, '→ isActive:', isActive);
    console.log('activeVCDFilterValues:', this.activeVCDFilterValues);
    if (wasActive && !isActive) {
      // console.log('Last VCD filter cleared');
    }
  }

  // ← get specific filter value anywhere in component
  private getFilterValue(colId: string): string {
    return this.activeVCDFilterValues.find(f => f.colId === colId)?.value ?? '';
  }


  onRowClicked(event: any) {
    // console.log('Row clicked: ', event.data);

  }

  onSelectionChanged() {
    // if(this.gridApi.getSelectedRows().length > 0)
    // { 
    //   this.isRowSelected = true;
    // }
    // else {
    //   this.isRowSelected = false;
    // }
    // console.log('Selected Rows: ', this.gridApi.getSelectedRows());
    this.isRowSelected = (this.gridApi?.getSelectedRows()?.length || 0) > 0;
  }

  windowPrint() {
    window.print();
  }
  goBack() {
    const vcdBack = true;
    this.commonService.vcdBackButtonActivated.next(vcdBack);
    this.router.navigate(['InventoryCampaignDetails'], {
      queryParams: {
        column: 'Market',
        value: this.commonService.marketScreenSelectedValue.getValue(),
      },
    });
  }
  notInInventory() {

    if (this.gridApi) {
      const selectedRows = this.gridApi.getSelectedRows();
      // console.log('Selected Rows for Not in Inventory:', selectedRows);
      const confirmNotInInventoryRows = selectedRows.map(row => {
        return row?.VINandAirLink;
      });
      console.log('Confirm Not in Inventory Rows:', confirmNotInInventoryRows);

    }
  }
  modalIsOpen = false;
  openMethod() {
    this.modalIsOpen = true;
  }
  submitComments() {
    this.formSubmitted = true;
    if (!this.notInInventoryForm.valid) {
      this.notInInventoryForm.markAllAsTouched();
      this.isSubmitting = false;
      return;
    }
    const commentVal = (this.notInInventoryForm.get('notInInventoryTextarea')?.value as string) ?? '';
    // console.log('Submitted Comments:', commentVal);
    // console.log('User Info:', this.userInfo);
    const payload = {
      "internal": environment.isB2E ? true : false,
      "dealer": environment.isB2D ? true : false,
      "userFName": this.userInfo?.given_name || "",
      "userLName": this.userInfo?.family_name || "",
      "qxId": this.userInfo?.subname || "",
      "centerID": this.dealerCode || " ",
      "vehNotInInvComment": commentVal,
      "campaignInventorySelectedVehicles": [
        ...this.gridApi.getSelectedRows().map(row => row?.VINandAirLink)
      ],

    }
    this.apiService.getRemovedVehiclesDealerInventoryData(payload).subscribe({
      next: (response: any) => {
        // console.log('Not in Inventory Response:', response);
        this.vinCount = parseInt(this.vinCount) - this.gridApi.getSelectedRows().length;
        // console.log('Updated VIN Count:', this.vinCount);
      },
      error: (error) => {
        console.error('Error in Not in Inventory:', error);
        this.failedDeletedToast();
      },
      complete: () => {
        console.log('Not in Inventory Request Complete');
        this.isSubmitting = true;
        this.modalIsOpen = false;
        if (this.gridApi) {
          this.gridApi.applyTransactionAsync({ remove: this.gridApi.getSelectedRows() });
          setTimeout(() => this.syncTableHeightToGridState());
        }
        this.successfullyDeletedToast();
        this.isSubmitting = false;
        this.notInInventoryForm.reset({ notInInventoryTextarea: '' });
        this.formSubmitted = false;
        this.comment = '';
        this.commonService.isSelectedNotInInventoryDeleted.next(true);
      }
    });

  }
  successfullyDeletedToast() {
    this.toastService.pushToast({
      id: 'error-toast',
      tone: 'positive',
      duration: 5000,
      title: 'Success',
      toastText: 'Successfully removed selected vehicles from inventory.'
    } as DsToastModel);
  }
  failedDeletedToast() {
    this.toastService.pushToast({
      id: 'error-toast',
      tone: 'critical',
      duration: 5000,
      title: 'Error',
      toastText: 'Failed to remove selected vehicles from inventory.'
    } as DsToastModel);
  }

  ngOnDestroy(): void {
    if (this.filterDebounceTimer) {
      clearTimeout(this.filterDebounceTimer);
      this.filterDebounceTimer = null;
    }
  }



}